import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import TalentManagementPage from "@/pages/admin/TalentManagementPage";

export const Route = createFileRoute("/_admin/admin/talent")({
  head: () => pageHead("Admin · Talent", "AKIVA admin · talent portal.", "/admin/talent", true),
  component: TalentManagementPage,
});
